import { fulfilled, pending, rejected } from '../../../utils';
import { RESET_PASSWORD } from '../../actions/actiontype';

const initialState = {
	status: '',
	loading: false,
	message: '',
	data: '',
	error: '',
};

const resetPasswordReducer = (state = initialState, action) => {
	switch (action.type) {
		case pending(RESET_PASSWORD):
			return {
				...state,
				loading: true,
				message: '',
				error: '',
			};
		case fulfilled(RESET_PASSWORD):
			return {
				...state,
				loading: false,
				status: action.payload.data.status,
				message: action.payload.data.message,
				data: action.payload.data.data,
				error: '',
			};
		case rejected(RESET_PASSWORD):
			return {
				...state,
				loading: false,
				message: '',
				error: status ===500 ? "Something went wrong. Please try again later" : action?.payload?.response.data.message,
			};
		default:
			return state;
	}
};

export default resetPasswordReducer;
